module.exports = __webpack_public_path__ + "static/media/Refresh Blue.c04c815e.svg";